module.exports = __webpack_public_path__ + "img/logo.6c7979fd.svg";